/* eslint-disable prettier/prettier */

import { _object } from 'utils/interfaces'
import { generateQueryParams } from 'utils'

import CommonService from './common.service'

class BrandsService extends CommonService {
  async getBrands(params: _object) {
    return await this.get(`/brands?${generateQueryParams(params)}`)
  }

  async getBrandsDetails(id: string | undefined) {
    return await this.get(`/brands/${id}`)
  }

  async addBrand(params: { [key: string]: string }) {
    return await this.post('/brands', params)
  }

  async UpdateBrand(id: string | undefined, params: { [key: string]: string }) {
    return await this.put(`/brands/${id}`, params)
  }

  async deleteBrand(id: string) {
    return await this.delete(`/brands/${id}`)
  }

    async brandHomePageText(params: _object) {
    return await this.post('/website-settings', params)
  }

}

export const brandsService = new BrandsService()
